import {parseRawUrls} from '../common';

export default parseRawUrls({
  accessibleparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/accessibleparrot.gif`,
  angelparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/angelparrot.gif`,
  angryparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/angryparrot.gif`,
  astronautparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/astronautparrot.gif`,
  aussieparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/aussieparrot.gif`,
  aussiecongaparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/aussiecongaparrot.gif`,
  badparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/badparrot.gif`,
  balconyparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/balconyparrot.gif`,
  beerparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/beerparrot.gif`,
  beretparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/beretparrot.gif`,
  bikerparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/bikerparrot.gif`,
  birthdaypartyparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/birthdaypartyparrot.gif`,
  bobaparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/bobaparrot.gif`,
  boomparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/boomparrot.gif`,
  boredparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/boredparrot.gif`,
  bouncingparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/bouncingparrot.gif`,
  calvinist_parrot: `${process.env.PUBLIC_URL}/./emojis/parrots/calvinist_parrot.gif`,
  ceilingparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/ceilingparrot.gif`,
  chefkissparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/chefkissparrot.gif`,
  chefparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/chefparrot.gif`,
  christmasparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/christmasparrot.gif`,
  coffeeparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/coffeeparrot.gif`,
  confusedparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/confusedparrot.gif`,
  congaparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/congaparrot.gif`,
  congapartyparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/congapartyparrot.gif`,
  copparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/copparrot.gif`,
  croissantparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/croissantparrot.gif`,
  daftpunkparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/daftpunkparrot.gif`,
  dealwithitparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/dealwithitparrot.gif`,
  deletedparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/deletedparrot.gif`,
  discoparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/discoparrot.gif`,
  docparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/docparrot.gif`,
  donutparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/donutparrot.gif`,
  everythingsfineparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/everythingsfineparrot.gif`,
  evilparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/evilparrot.gif`,
  fastparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/fastparrot.gif`,
  flowerparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/flowerparrot.gif`,
  flyingmoneyparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/flyingmoneyparrot.gif`,
  footballparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/footballparrot.gif`,
  gentlemanparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/gentlemanparrot.gif`,
  glimpseparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/glimpseparrot.gif`,
  gothparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/gothparrot.gif`,
  hackerparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/hackerparrot.gif`,
  halalparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/halalparrot.gif`,
  hanamiparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/hanamiparrot.gif`,
  hardhatparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/hardhatparrot.gif`,
  headbangingparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/headbangingparrot.gif`,
  headingparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/headingparrot.gif`,
  hypnoparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/hypnoparrot.gif`,
  imposterparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/imposterparrot.gif`,
  jediparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/jediparrot.gif`,
  jumpingparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/jumpingparrot.gif`,
  laptop_parrot: `${process.env.PUBLIC_URL}/./emojis/parrots/laptop_parrot.gif`,
  maracasparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/maracasparrot.gif`,
  mardigrasparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/mardigrasparrot.gif`,
  marshmallowparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/marshmallowparrot.gif`,
  maskparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/maskparrot.gif`,
  michaeljacksonparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/michaeljacksonparrot.gif`,
  moonparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/moonparrot.gif`,
  moonwalkingparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/moonwalkingparrot.gif`,
  mustacheparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/mustacheparrot.gif`,
  parrot: `${process.env.PUBLIC_URL}/./emojis/parrots/parrot.gif`,
  parrotnotfound: `${process.env.PUBLIC_URL}/./emojis/parrots/parrotnotfound.gif`,
  partyparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/partyparrot.gif`,
  picassoparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/picassoparrot.gif`,
  pingpongparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/pingpongparrot.gif`,
  pirateparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/pirateparrot.gif`,
  playcatchleftparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/playcatchleftparrot.gif`,
  playcatchrightparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/playcatchrightparrot.gif`,
  pokeparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/pokeparrot.gif`,
  popcornparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/popcornparrot.gif`,
  portalblueparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/portalblueparrot.gif`,
  portalorangeparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/portalorangeparrot.gif`,
  pumpkinparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/pumpkinparrot.gif`,
  quadparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/quadparrot.gif`,
  redbullparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/redbullparrot.gif`,
  redenvelopeparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/redenvelopeparrot.gif`,
  reversecongaparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/reversecongaparrot.gif`,
  reverseparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/reverseparrot.gif`,
  reverseportalblueparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/reverseportalblueparrot.gif`,
  reverseportalorangeparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/reverseportalorangeparrot.gif`,
  revolutionparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/revolutionparrot.gif`,
  ripparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/ripparrot.gif`,
  sadparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/sadparrot.gif`,
  scienceparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/scienceparrot.gif`,
  sherlockholmesparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/sherlockholmesparrot.gif`,
  shortparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/shortparrot.gif`,
  shuffleparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/shuffleparrot.gif`,
  sidewaysparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/sidewaysparrot.gif`,
  sithparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/sithparrot.gif`,
  sleepingparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/sleepingparrot.gif`,
  slowparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/slowparrot.gif`,
  sneezyparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/sneezyparrot.gif`,
  soccerparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/soccerparrot.gif`,
  spinningparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/spinningparrot.gif`,
  spyparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/spyparrot.gif`,
  stableparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/stableparrot.gif`,
  stayhomeparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/stayhomeparrot.gif`,
  sushiparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/sushiparrot.gif`,
  tennisparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/tennisparrot.gif`,
  thankyouparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/thankyouparrot.gif`,
  tinfoilhatparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/tinfoilhatparrot.gif`,
  twinsparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/twinsparrot.gif`,
  unicornparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/unicornparrot.gif`,
  vacationparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/vacationparrot.gif`,
  wfhparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/wfhparrot.gif`,
  wineparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/wineparrot.gif`,
  zombieparrot: `${process.env.PUBLIC_URL}/./emojis/parrots/zombieparrot.gif`,
});
